import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { NavLink } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

// const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Navigation = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const { user, logOut } = useAuth()
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="fixed">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                    >
                        Ghurbo
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {/* {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))} */}

                            <NavLink style={{ textDecoration: 'none' }} to={'/home'}><Button sx={{ color: 'black' }}>Home</Button></NavLink><br />
                            {
                                user?.email ?

                                    <>
                                        <NavLink style={{ textDecoration: 'none' }} to={'/myorders'}><Button sx={{ color: 'black' }}>My Orders</Button></NavLink><br />
                                        <NavLink style={{ textDecoration: 'none' }} to={'/allorders'}><Button sx={{ color: 'black' }}>Manage All Orders</Button></NavLink><br />
                                        <NavLink style={{ textDecoration: 'none' }} to={'/newpackage'}><Button sx={{ color: 'black' }}>Add a New Package</Button></NavLink><br />
                                        <Button onClick={logOut} sx={{ color: 'black' }}>LogOut</Button>

                                    </>

                                    :
                                    <NavLink style={{ textDecoration: 'none' }} to={'/login'}><Button sx={{ color: 'black' }}>Login</Button></NavLink>
                            }

                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
                    >
                        Ghurbo
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {/* {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page}
                            </Button>
                        ))} */}
                        <NavLink style={{ textDecoration: 'none' }} to={'/home'}><Button sx={{ color: 'white' }}>Home</Button></NavLink>
                        {
                            user?.email ?

                                <>
                                    <NavLink style={{ textDecoration: 'none' }} to={'/myorders'}><Button sx={{ color: 'white' }}>My Orders</Button></NavLink>
                                    <NavLink style={{ textDecoration: 'none' }} to={'/allorders'}><Button sx={{ color: 'white' }}>Manage All Orders</Button></NavLink>
                                    <NavLink style={{ textDecoration: 'none' }} to={'/newpackage'}><Button sx={{ color: 'white' }}>Add a New Package</Button></NavLink>
                                    <Button onClick={logOut} sx={{ color: 'white' }}>LogOut</Button>

                                </>

                                :
                                <NavLink style={{ textDecoration: 'none' }} to={'/login'}><Button sx={{ color: 'white' }}>Login</Button></NavLink>
                        }




                    </Box>

                    {/* <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Open settings">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box> */}
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navigation;